export enum AppPaths {
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	OFFERS = 'offers',
	PRODUCT_TYPES = 'product-types',

	ADMINS = 'admins',

	ATTRIBUTES = 'attributes',
	ATTRIBUTE_VALUES = 'attribute-values',

	ACCESSORIES = 'accessories',
	ACCESSORY_CATEGORIES = 'accessory-categories',

	MATERIALS = 'materials',
	MODELS = 'models',
	ROLES = 'roles',
	CONTENT = 'content',
}
